// extracted by mini-css-extract-plugin
export var connectionButton = "_bj-1";
export var connectionButtonFloating = "_bj-2";
export var connectionContainer = "_bj-0";
export var rightPanel = "_bj-6";
export var stepCard = "_bj-3";
export var stepCardSubtitle = "_bj-5";
export var stepCardText = "_bj-4";